import {
  Avatar,
  List,
  ListItem,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { GreenCheckMark } from 'Images';

interface ISpecialServices {
  services: boolean[];
}

export const SpecialServices = ({ services }: ISpecialServices) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage
    .therapy;

  const listItemSx: SxProps = {
    p: '0 0 0 8px',
    '&::before': {
      content: '"\\2022"',
      fontSize: '20px',
      marginRight: '8px',
    },
  };

  if (services.every((service: boolean) => service === false)) return null;

  return (
    <Stack
      gap='8px'
      sx={{
        width: '100%',
        maxWidth: '307px',
      }}
    >
      <Typography
        variant='body5'
        component='h4'
        sx={{
          cursor: 'text',
        }}
      >
        {dictionary.specialService}
      </Typography>
      <List sx={{ listStyleType: 'disc', listStylePosition: 'inside', p: 0 }}>
        {services.map((service, index: number) => {
          if (!service) return null;
          const isAccessible = index === 0;
          return (
            <ListItem key={index} sx={{ ...listItemSx }}>
              <Typography
                variant='body3'
                sx={{
                  cursor: 'text',
                }}
              >
                {isAccessible ? dictionary.accessible : dictionary.homeTherapy}
              </Typography>
              {isAccessible && (
                <Avatar
                  alt=''
                  src={GreenCheckMark}
                  sx={{ width: '20px', height: '20px', ml: '5px' }}
                />
              )}
            </ListItem>
          );
        })}
      </List>
    </Stack>
  );
};
